<script>

</script>

<template>

    <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden... / Loading...</span>
    </div>

</template>
